import request from '@/plugins/http';
// 洲列表
export const stateList = (data) => {
  return request({
    url: '/api/v1/common/stateList',
    method: 'post',
    data
  });
};
// 校验邮编
export const checkStateZipCode = (data) => {
  return request({
    url: '/api/v1/common/checkStateZipCode',
    method: 'post',
    data
  });
};
// 邮箱校验
export const checkEmail = (data) => {
  return request({
    url: `/api/v1/promotion/checkEmail?email=${data}`,
    method: 'post'
  });
};

// 折扣码校验
export const checkCoupon = (data) => {
  return request({
    url: `/api/v1/order/checkCoupon`,
    method: 'get',
    params: data
  });
};

// 推荐码校验
export const checkReferCode = (data) => {
  return request({
    url: `/api/v1/common/checkReferCode`,
    method: 'post',
    data
  });
};
